import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PartnersOverviewComponent } from './partners-overview/partners-overview.component';

export const routes: Routes = [
    { path: '', redirectTo: 'overview', pathMatch: 'full' },
    { path: 'overview', component: PartnersOverviewComponent },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
